<template>
  <div id="programme-projects">
    <k-panel
      title="Instructions"
      :showContent="show" @toggle="(val) => show = val"
    >
    <template #body>
      <project-instructions />
    </template>
    </k-panel>
    <k-panel
      :hasContentToggle="false"
    >
      <template #header>
        <div class="panel-heading">
          <div class="header-right">
            <button class="btn btn-success" @click="createProjectScope">
              <i class="fas fa-edit" aria-hidden="true"></i> Add new project
            </button>
          </div>
        </div>
      </template>
      <template #body>
        <project-table
          v-if="projects && projects.length > 0"
          :projects="projects"
          :projects-ready="projectsReady"
          :open-feedback-modal="openFeedbackModal"
          :open-evidence-page="openEvidencePage"
          @edit-project="editProjectScope"
          @view-all-feedback="openFeedbackModal"
        />
        <empty-placeholder
          v-else
          fa-icon="fas fa-file-lines"
          title="No projects found"
          info="There are no projects for this programme yet. Click the 'Add new project' button to get started."
        ></empty-placeholder>
      </template>
    </k-panel>
    <add-edit-project-scope
      :show-modal="showScopeModal"
      @close="handleScopeModalClose"
      :programme-id="programmeId"
      :modal-mode="modalMode"
      :scope-data="scopeToEdit"
      @update="handleProjectUpdate"
    />
    <view-all-project-feedback
      :show-modal="showFeedbackModal"
      :programme-id="programmeId"
      :project-id="projectId"
      @close="handleFeedbackModalClose"
    />
  </div>
</template>

<style scoped>
.header-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
}
</style>

<script>
import KPanel from '@base-components/k-panel.vue';
import EmptyPlaceholder from '@base-components/empty-placeholder.vue';
import ProjectInstructions from './project_tracker_components/project-tracker-instructions.vue';
import ProjectTable from './project_tracker_components/project-tracker-table.vue';
import AddEditProjectScope from './project_tracker_components/add-edit-project-scope.vue';
import ViewAllProjectFeedback from './project_tracker_components/view-all-project-feedback.vue';

export default {
  components: {
    KPanel,
    ProjectInstructions,
    ProjectTable,
    AddEditProjectScope,
    EmptyPlaceholder,
    ViewAllProjectFeedback,
  },

  props: {
    programmeId: {
      type: Number,
      required: true,
    },
    projects: {
      type: Array,
    },
    projectsReady: {
      type: Boolean,
      default: false,
    },
    getProjects: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      show: false,
      showScopeModal: false,
      modalMode: 'create', // 'create', 'edit', 'view'
      scopeToEdit: undefined,
      showFeedbackModal: false,
      projectId: undefined,
    };
  },

  methods: {
    createProjectScope() {
      this.scopeToEdit = undefined;
      this.showScopeModal = true;
      this.modalMode = 'create';
    },

    editProjectScope(projectId) {
      // Get the project data from the projects prop
      const project = this.projects.find(p => p.id === projectId);
      this.scopeToEdit = project;
      this.showScopeModal = true;

      this.modalMode = this.scopeToEdit?.scoping_completed || this.scopeToEdit?.project_completed ? 'view' : 'edit';
    },

    handleScopeModalClose() {
      this.showScopeModal = false;
      this.scopeToEdit = undefined;
    },

    handleFeedbackModalClose() {
      this.showFeedbackModal = false;
      this.projectId = undefined;
    },

    handleProjectUpdate() {
      this.getProjects();
    },

    openFeedbackModal(projectId) {
      this.showFeedbackModal = true;
      this.projectId = projectId;
    },

    openEvidencePage(projectId) {
      this.$router.push({
        name: 'manage_programme_evidence',
        params: {
          programmeId: this.programmeId,
          projectId,
        },
      });
    },
  },
};
</script>
